import { AgentType } from './agent-types';
import { ArtifactType } from './artifact-digest-types';

export enum DeliverableStatus {
  PENDING = 'Pending',
  SATISFIED = 'Satisfied',
  BYPASSED = 'Bypassed',
}

export enum DeliverableMatchStatus {
  NEEDS_REVIEW = 'Needs Review',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
}

export interface DeliverableAgentContext {
  rationale?: string | null;
}

export interface DeliverableArtifactCriteria {
  search_keywords?: string[] | null;
  exclusion_keywords?: string[] | null;
}

export interface DeliverableAnchors {
  facts: Record<string, string>;
}

export interface BaseDeliverable {
  name: string;
  prompt: string;
  artifact_criteria?: DeliverableArtifactCriteria | null;
  anchors?: DeliverableAnchors | null;
  status?: DeliverableStatus | null;
}

export interface CreateDeliverable extends BaseDeliverable {
  task_id: string;
}

export type UpdateDeliverable = BaseDeliverable;

export interface Deliverable extends BaseDeliverable {
  id: string;
  task_id: string;
  created_at: string;
  modified_at: string;
  user_id?: string | null;
  agent?: AgentType | null;
  agent_context?: DeliverableAgentContext | null;
  requires_evidence?: boolean;
  matches: DeliverableMatch[];
}

export interface DeliverableStub {
  id: string;
  name: string;
  prompt: string;
  status?: DeliverableStatus | null;
  satisfied_at?: string | null;
  matches: DeliverableMatchStub[];
}

// Deliverable Match types
export interface DeliverableMatchContext {
  rationale?: string | null;
  key_evidence?: string[] | null;
}

export interface BaseDeliverableMatch {
  status?: DeliverableMatchStatus | null;
  confidence?: number | null;
  context?: DeliverableMatchContext | null;
}

export interface CreateDeliverableMatch extends BaseDeliverableMatch {
  deliverable_id: string;
  artifact_id?: string | null;
  front_conversation_id?: string | null;
}

export interface UpdateDeliverableMatch extends BaseDeliverableMatch {
  id: string;
}

export interface DeliverableMatch extends BaseDeliverableMatch {
  id: string;
  deliverable_id: string;
  artifact_id?: string | null;
  artifact_type?: ArtifactType | null;
  artifact_name?: string | null;
  front_conversation_id?: string | null;
  created_at: string;
  modified_at: string;
  user_id?: string | null;
  user_name?: string | null;
  agent?: AgentType | null;
}

export interface DeliverableMatchStub {
  id: string;
  artifact_id?: string | null;
  artifact_type?: ArtifactType | null;
  front_conversation_id?: string | null;
  status?: DeliverableMatchStatus | null;
  confidence?: number | null;
  agent?: AgentType | null;
  user_name?: string | null;
}

export interface DeleteDeliverable {
  id: string;
}

export interface DeleteDeliverableMatch {
  id: string;
}

// Summary types for API responses
export interface DeliverableSummary {
  total: number;
  pending: number;
  satisfied: number;
  bypassed: number;
}
